<template>
  <div style="overflow: hidden;">
    <nav class="navbar navbar-expand-lg navbar-inverse">
      <router-link class="navbar-brand" to="#" id="nav-logo">
        <img
          src="../assets/logo.png"
          alt="meetbeans logo"
          style="width: 200px;"
        />
      </router-link>
      <span id="room-name" class="d-none d-sm-block">
        {{ user.name !== "" ? "Welcome " + user.name + "👋 | " : "Channel :" }}
        <b>{{ session.session_name.toUpperCase() }}</b>
      </span>
      <button
        class="navbar-toggler btn-primary"
        type="button"
        data-toggle="collapse"
        data-target="#navbarTogglerMenu"
        aria-controls="navbarTogglerMenu"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <i class="fas fa-bars navbar-toggler-icon" style="font-size: 25px;"></i>
      </button>
      <div class="collapse navbar-text navbar-collapse" id="navbarTogglerMenu">
        <ul class="navbar-nav ml-auto mt-lg-0">
          <!--					<li-->
          <!--						class="nav-item active mr-3"-->
          <!--						v-if="this.$store.state.role === 'host'"-->
          <!--					>-->
          <!--						<button-->
          <!--							class="btn btn-outline-primary"-->
          <!--							data-toggle="modal"-->
          <!--							data-target="#invite"-->
          <!--							id="nav-invite-audience"-->
          <!--							@click="onStageFunction(false)"-->
          <!--						>-->
          <!--							Invite-->
          <!--						</button>-->
          <!--					</li>-->
          <li
            class="nav-item active mr-3"
            v-if="
              this.$store.state.role === 'host' || this.$store.state.isSpeaker
            "
          >
            <button
              class="btn btn-primary"
              id="nav-go-to-lounge"
              v-if="
                this.$store.state.isStage === true &&
                  this.$store.state.isLive === false
              "
              @click="onStageFunction(false)"
            >
              Meet Audience
            </button>
            <button
              class="btn btn-primary"
              id="nav-go-to-backstage"
              v-if="
                this.$store.state.isStage === false &&
                  this.$store.state.isLive === false &&
                  this.$store.state.isBreak === false &&
                  !this.$store.state.showPermission
              "
              @click="onStageFunction(true)"
            >
              Enter Studio
            </button>
            <button
              class="btn-primary btn"
              id="nav-go-to-resume-event"
              v-if="
                this.$store.state.isStage === false &&
                  this.$store.state.isLive === false &&
                  this.$store.state.isBreak === true
              "
              @click="onStageFunction(true)"
            >
              Resume Event
            </button>
          </li>
          <li class="nav-item">
            <a
              href="javascript:void(0)"
              v-if="uid"
              id="nav-meeting-exit-with-login"
              class="btn btn-outline-primary"
              @click="callExit()"
            >
              Lobby
              <i class="fas fa-sign-out-alt"></i>
            </a>
            <router-link
              to="/"
              class="btn btn-primary"
              id="nav-meeting-exit-without-login"
              v-else
            >
              Exit
              <i class="fas fa-sign-out-alt"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <div v-if="allowBrowser">
    <div v-if="this.$store.state.showPermission">
      <EventSetting></EventSetting>
    </div>
    <div
      v-else
      id="wrapper"
      style="overflow: hidden;"
      class="container-fluid wrapper meeting d-none d-sm-block"
    >
      <div v-if="user.name" style="display: flex;">
        <div class="flex-width">
          <div class="card" style="border-radius: 10px;">
            <div
              class="card-body wrapper meeting p-0"
              style="height: 85vh; min-height: 350px; overflow: auto;"
            >
              <div
                v-if="this.$store.state.isLive"
                class="ag-main"
                id="video-call"
              >
                <div
                  class="ag-container"
                  v-if="this.$store.state.isChatConnect && !isMobile"
                >
                  <div>
                    <VideoCall
                      :videoProfile="videoProfile"
                      :channel="channel"
                      :transcode="transcode"
                      :attendeeMode="attendeeMode"
                      :baseMode="baseMode"
                      :appId="appId"
                      :uid="uid"
                      @getUid="initUid"
                    ></VideoCall>
                  </div>
                </div>
                <div
                  class="ag-container text-center"
                  v-else-if="
                    this.$store.state.isChatConnect && isMobile && mobileLive
                  "
                >
                  <div style="margin-top: 20px" v-if="liveStreamUrl === ''">
                    <i class="fas fa-broadcast-tower" style="font-size: 60px;"></i>
                    <h5
                      style="font-weight: lighter; font-size: 21px;margin-top: 20px"
                    >
                      Broadcast will happen here
                    </h5>
                  </div>
                  <div v-else>
                    <video-player style="width:100%;border: 3px solid #fefefe" :options="{autoplay: true, controls: true, sources: {src: liveStreamUrl, type: 'application/x-mpegURl'}, html5: {vhs: {overrideNative: true}}}"/>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="this.$store.state.isStage">
                  <Backstage :attendeeMode="attendeeMode"></Backstage>
                </div>
                <div v-else>
                  <div
                   class="text-center"
                    style="margin-top: 20px"
                    v-show="defaultMobile && isMobile"
                  >
                    <i class="fas fa-broadcast-tower" style="font-size: 60px;"></i>
                    <!--			    <h1 style="font-size: 50px; margin-bottom: 0px;"><b></b></h1>-->
                    <h5
                      style="font-weight: lighter; font-size: 21px;margin-top: 20px"
                    >
                      Broadcast will happen here
                    </h5>
                  </div>
                  <div v-if="mobileLounge && isMobile">
                    <social></social>
                  </div>
                  <div v-if="!isMobile">
                    <social></social>
                  </div>
                </div>
              </div>
              <div class="hidden-xs hidden-sm-up" v-if="isMobile">
                <div
                  class="card"
                  id="chat"
                  style="background: #101010; height: auto !important;border-radius: 0"
                  v-show="mobileChats && isMobile"
                >
                  <!-- <div class="card-header"><b>Chats</b></div> -->
                  <div
                    class="card-body p-2"
                    v-if="uid !== undefined && isMobile"
                  >
                    <AgoraChatRoom :uid="uid"></AgoraChatRoom>
                  </div>
                  <div
                    v-else
                    v-show="isMobile"
                    class="card-body"
                    style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%); text-align: center"
                  >
                    <svg
                      width="60"
                      height="60"
                      style="margin-bottom: 5%;"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <image
                        href="../assets/no-message.svg"
                        width="60"
                        height="60"
                      />
                    </svg>
                    <br />
                    <span>
                      <b>You are the first</b>
                    </span>
                    <p>No has joined till this time.</p>
                  </div>
                </div>
                <div
                  class="card"
                  id="question_chat_mobile"
                  style="background: #101010; height: 80vh !important;;border-radius: 0"
                  v-show="mobileQnA && isMobile"
                >
                  <!-- <div class="card-header"><b>Chats</b></div> -->
                  <div
                    class="card-body p-2"
                    v-if="uid !== undefined && isMobile"
                    v-show="mobileQnA && isMobile"
                  >
                    <AgoraQuestionChat></AgoraQuestionChat>
                    <div
                      v-if="!this.$store.state.isChatConnect"
                      class="chat-loading"
                    >
                      <h1>Connecting...</h1>
                    </div>
                  </div>
                  <div
                    v-else
                    v-show="isMobile"
                    class="card-body"
                    style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%); text-align: center"
                  >
                    <svg
                      width="60"
                      height="60"
                      style="margin-bottom: 5%;"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <image href="../assets/qna.svg" width="60" height="60" />
                    </svg>
                    <br />
                    <span>
                      <b>You are the first</b>
                    </span>
                    <p>Ask some questions here.</p>
                  </div>
                </div>
                <div
                  class="card"
                  style="background: #101010;;border-radius: 0"
                  v-show="mobileAudience && isMobile"
                >
                  <!-- <div class="card-header">
									<b>Audience</b>
								</div>-->
                  <div
                    class="card-body"
                    style="height: 80vh; overflow-y: auto;"
                  >
                    <div
                      class="btn-group"
                      role="group"
                      aria-label="Basic example"
                      style="width: 70%; margin: 0px 50px;"
                    >
                      <button
                        @click="showGridView"
                        id="gridViewId"
                        type="button"
                        class="btn btn-outline-primary activeView btn-sm"
                        style="font-size: 12px;"
                      >
                        Grid
                      </button>
                      <button
                        @click="showListView"
                        id="listViewId"
                        type="button"
                        class="btn btn-outline-primary btn-sm"
                        style="font-size: 12px;"
                      >
                        List
                      </button>
                    </div>
                    <hr />
                    <div
                      class="audience"
                      v-if="audience.length > 0 && listview_bool"
                    >
                      <div
                        class="card card-white mb-2"
                        style="background: #1b1b1b; border: 0.1px solid #1b1b1b; border-radius: 8px"
                        v-for="(a, i) in audience"
                        :key="i"
                      >
                        <div class="card-body p-2">
                          <div style="display: flex">
                            <div style="width: 50px; margin: 2px;">
                              <img
                                class="img-responive"
                                :src="a.photoURL"
                                style="width: 100%; border: 1px solid #979797; border-radius: 12px"
                                :alt="a"
                              />
                            </div>
                            <div style="width: -moz-available;" class="m-1">
                              <b v-if="a.name !== ''">{{ a.name }}</b>
                              <b v-else>User Name</b>
                              <p class="mb-0">
                                <small class v-if="a.role === 'host'"
                                  >Host</small
                                >
                                <small class v-else-if="a.role === 'speaker'"
                                  >Speaker</small
                                >
                                <small class v-else>Attendee</small>
                              </p>
                            </div>
                            <!--<button class="chatButton">Chat</button>-->
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      class="audience"
                      v-else-if="audience.length > 0 && gridview_bool"
                    >
                      <div
                        class="row"
                        style="background: #101010;border-radius: 8px"
                      >
                        <div
                          class="column"
                          v-for="(a, i) in audience"
                          :key="i"
                          style="background-color: #1b1b1b; padding: 2px; border-radius: 10px; margin: 1px;"
                        >
                          <img
                            alt="picture"
                            :src="a.photoURL"
                            class="img-fluid"
                            style="width: 50px;"
                          />
                          <div class="audienceTooltip">
                            <!-- <b v-if="a.name !== '' && a.name.length > 11">{{ a.name.slice(0, 10) }}...</b> -->
                            <b
                              v-if="a.name !== '' && a.name.length <= 15"
                              style="font-size: 12px;"
                              >{{ a.name }}</b
                            >
                            <b
                              v-else-if="a.name !== '' && a.name.length > 15"
                              style="font-size: 12px;"
                              >{{ a.name.slice(0, 15) }}..</b
                            >
                            <!-- <b v-if="a.name !== '' && a.name.length <= 10">{{ a.name}}</b> -->
                            <b v-else>User Name</b>
                            <p class="mb-0" style="font-size: 10px;">
                              <small class v-if="a.role === 'host'">Host</small>
                              <small class v-else-if="a.role === 'speaker'"
                                >Speaker</small
                              >
                              <small class v-else>Attendee</small>
                            </p>
                          </div>
                          <div class="triangle-up"></div>
                        </div>
                        <!-- <div style="width: 65px; margin: 2px;">
														<img
															class="col-md-4"
															:src="a.photoURL"
															style="width: 100%; height: 100%; border: 1px solid #979797; border-radius: 12px"
															:alt="a"
														/>
													</div> -->
                        <!-- <div style="width: -moz-available" class="ml-1">
														<b v-if="a.name !== ''">{{ a.name }}</b>
														<b v-else>User Name</b>
														<p class="mb-0">
															<small class v-if="a.role === 'host'">Host</small>
															<small class v-else-if="a.role === 'speaker'"
																>Speaker</small
															>
															<small class v-else>Attendee</small>
														</p>
													</div> -->
                        <!-- <button class="chatButton">Chat</button>-->
                      </div>
                    </div>
                    <div
                      class="audience text-center"
                      v-else
                      style="min-height: 350px;"
                    >
                      <div
                        style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%)"
                      >
                        <svg
                          width="60"
                          height="60"
                          style="margin-bottom: 5%;"
                          xmlns="http://www.w3.org/2000/svg"
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                        >
                          <image
                            href="../assets/audience.svg"
                            width="60"
                            height="60"
                          />
                        </svg>
                        <br />
                        <span>
                          <b>You are the first</b>
                        </span>
                        <p>No has joined till this time.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="mr-1"
          id="collapsibleNavbar--w-420"
          style="margin-left: 10px;width: 420px;border: 10px solid rgb(27, 27, 27);border-radius: 10px;height: 85vh;"
          v-if="!isMobile"
        >
          <div style="display: flex" v-if="!isMobile">
            <div
              class="m-0"
              id="collapsibleNavbar--w-0"
              style="min-width: 330px;height: 85vh;"
            >
              <div
                class="card"
                id="chat"
                style="background: #101010; height: 80vh !important; display: none;"
              >
                <!-- <div class="card-header"><b>Chats</b></div> -->
                <div
                  class="card-body p-2"
                  v-if="uid !== undefined && !isMobile"
                >
                  <AgoraChatRoom :uid="uid"></AgoraChatRoom>
                </div>
                <div
                  v-else
                  class="card-body"
                  style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%); text-align: center"
                >
                  <svg
                    width="60"
                    height="60"
                    style="margin-bottom: 5%;"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <image
                      href="../assets/no-message.svg"
                      width="60"
                      height="60"
                    />
                  </svg>
                  <br />
                  <span>
                    <b>You are the first</b>
                  </span>
                  <p>No has joined till this time.</p>
                </div>
              </div>
              <div
                class="card"
                id="question_chat"
                style="background: #101010; height: 80vh !important; display: none;"
              >
                <!-- <div class="card-header"><b>Chats</b></div> -->
                <div
                  class="card-body p-2"
                  v-if="uid !== undefined && !isMobile"
                >
                  <!-- <div
                    class="btn-group"
                    role="group"
                    aria-label="Basic example"
                    style="width: 100%; display: inline-flex; justify-content: center;margin-top: 10px"
                  >
                  <ul class="nav nav-tabs">
                    <li class="active">
                      <a data-toggle="tab" id="questionsBtn" href="#questions" class="btn btn-outline-primary activeView btn-sm">Questions</a>
                    </li>
                    <li><a data-toggle="tab" id="pollsBtn" href="#polls" class="btn btn-outline-primary btn-sm">Polls</a></li>
                  </ul>
                  </div> -->
                  <!-- <hr style="margin-top: 15px;width: 90%; color: #cfcfcf"> -->
                  <!-- <div class="tab-content">
                    <div id="questions" class="tab-pane fade in active"> -->
                  <AgoraQuestionChat></AgoraQuestionChat>
                  <!-- </div>
                  </div> -->
                  <div
                    v-if="!this.$store.state.isChatConnect"
                    class="chat-loading"
                  >
                    <h1>Connecting...</h1>
                  </div>
                </div>
                <div
                  v-else
                  class="card-body"
                  style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%); text-align: center"
                >
                  <svg
                    width="60"
                    height="60"
                    style="margin-bottom: 5%;"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <image href="../assets/qna.svg" width="60" height="60" />
                  </svg>
                  <br />
                  <span>
                    <b>You are the first</b>
                  </span>
                  <p>Ask some questions here.</p>
                </div>
              </div>
              <div
                class="card"
                v-if="sessions_bool"
                style="background: #101010; height: 80vh !important;"
              >
                <div class="card-header">
                  <a
                    href="javascript:void(0)"
                    v-if="!eventLobby"
                    @click="eventLobby = true"
                    ><i class="fas fa-arrow-left"></i
                    ><b style="color: #fff;"> Back to lobby</b></a
                  >
                  <a
                    href="javascript:void(0)"
                    v-else
                    @click="eventLobby = false"
                    ><i class="fas fa-times"></i>
                    <b style="color: #fff;"> Back to current auditorium</b></a
                  >
                </div>
                <div
                  class="card-body"
                  style="height: 80vh; overflow-y: auto;"
                  v-if="eventLobby"
                >
                  <div style="margin-bottom: 150px;">
                    <h4
                      style="text-align: center; font-family: 'Vidaloka', serif;"
                    >
                      {{ event.title }}
                    </h4>
                    <div
                      class="card mb-1 mt-1"
                      v-for="(s, i) in event.sessions"
                      :key="i"
                    >
                      <div class="card-body p-1">
                        <div class="row">
                          <div
                            class="col-12 col-md-3"
                            style="text-align: -moz-center;text-align: -webkit-center;"
                          >
                            <small>Audi</small>
                            <h5>
                              <b>{{ i + 1 }}</b>
                            </h5>
                          </div>
                          <div class="col-12 col-md-9" style="text-align: left">
                            <h5 class="mb-0" style="font-size: 16px;">
                              <b>{{
                                s.session_name >= 12
                                  ? s.session_name.substr(0, 12) + ".."
                                  : s.session_name
                              }}</b>
                            </h5>
                            <span
                              style="font-size: 10px;"
                              v-for="(u, index) in s.speakers"
                              :key="index"
                              ><span v-if="index !== 0">,</span> {{ u.name }}
                            </span>
                            <p class="text-muted">
                              {{ s.session_description.slice(0, 30) }}..
                            </p>
                            <a
                              style="cursor:pointer;"
                              href="#navigateModal"
                              data-toggle="modal"
                              @click="navigateAudi(s)"
                              class="text-primary float-right"
                              ><i class="fas fa-arrow-right"></i
                            ></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="event.sponsors.length > 0"
                    style="position: absolute; bottom: 0px; width: 90%; background: #101010"
                  >
                    <h5
                      style="text-align: center; font-family: 'Vidaloka', serif;margin-top: 3%;"
                    >
                      Event Sponsors
                    </h5>
                    <carousel-3d
                      v-if="event.sponsors.length >= 3"
                      :autoplay="true"
                      :autoplay-timeout="5000"
                      :controls-visible="true"
                      :controls-prev-html="'&#10092;'"
                      :controls-next-html="'&#10093;'"
                      :clickable="true"
                      :display="3"
                      :width="200"
                      :height="80"
                    >
                      <slide
                        v-for="(slide, i) in event.sponsors"
                        :index="i"
                        :key="i"
                        class="text-center"
                      >
                        <template
                          slot-scope="{
                            index,
                            isCurrent,
                            leftIndex,
                            rightIndex,
                          }"
                        >
                          <figure
                            data-toggle="modal"
                            data-target="#sponsorModal"
                            @click="openSponsor(slide)"
                            style="cursor: pointer"
                          >
                            <img
                              style="width: 60px; height: 60px; text-align: center; border-radius: 50%;"
                              :data-index="index"
                              :class="{
                                current: isCurrent,
                                onLeft: leftIndex >= 0,
                                onRight: rightIndex >= 0,
                              }"
                              :src="slide.sponsor_img"
                            />
                            <figcaption>
                              <b>{{ slide.sponsor_name }}</b>
                            </figcaption>
                          </figure>
                        </template>
                      </slide>
                    </carousel-3d>
                    <div class="row" v-else-if="event.sponsors.length === 2">
                      <div
                        class="col-6 text-center"
                        v-for="(slide, i) in event.sponsors"
                        :key="i"
                      >
                        <figure
                          data-toggle="modal"
                          data-target="#sponsorModal"
                          @click="openSponsor(slide)"
                          style="cursor: pointer"
                        >
                          <img
                            style="width: 60px; height: 60px; text-align: center; border-radius: 50%;"
                            :src="slide.sponsor_img"
                          />
                          <figcaption>
                            <b>{{ slide.sponsor_name }}</b>
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                    <div class="row" v-else-if="event.sponsors.length === 1">
                      <div
                        class="col-12 text-center"
                        v-for="(slide, i) in event.sponsors"
                        :key="i"
                      >
                        <figure
                          data-toggle="modal"
                          data-target="#sponsorModal"
                          @click="openSponsor(slide)"
                          style="cursor: pointer"
                        >
                          <img
                            style="width: 60px; height: 60px; text-align: center; border-radius: 50%;"
                            :src="slide.sponsor_img"
                          />
                          <figcaption>
                            <b>{{ slide.sponsor_name }}</b>
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="card-body"
                  style="height: 80vh;  overflow-y: auto;"
                  v-else
                >
                  <div style="margin-bottom: 150px;">
                    <h4
                      style="text-align: center; font-family: 'Vidaloka', serif;"
                    >
                      {{ session.session_name }}
                    </h4>
                    <div v-if="!readMoreActivated">
                      <p class="text-muted">
                        {{ session.session_description.slice(0, 30) }}
                        <a
                          href="javascript:void(0)"
                          v-if="
                            !readMoreActivated &&
                              session.session_description.length > 30
                          "
                          @click="readMoreActivated = true"
                        >
                          read more...
                        </a>
                      </p>
                    </div>
                    <div v-if="readMoreActivated">
                      <p class="text-muted">
                        {{ session.session_description }}
                        <a
                          href="javascript:void(0)"
                          @click="readMoreActivated = false"
                        >
                          less
                        </a>
                      </p>
                    </div>
                    <div
                      class="card mb-1 mt-1"
                      v-for="(s, i) in session.speakers"
                      :key="i"
                    >
                      <div class="card-body p-1">
                        <div class="row">
                          <div class="col-4">
                            <div class="text-center">
                              <img
                                :src="s.photoURL"
                                alt=""
                                style="width: 100%; border-radius: 12px;"
                              />
                              <label
                                class="badge badge-info"
                                style="position: absolute; left: 10px; bottom:0;"
                                >Speaker</label
                              >
                            </div>
                          </div>
                          <div class="col-8" style="text-align: left">
                            <div style="font-size: 16px;">
                              <b>{{ s.name }}</b>
                            </div>
                            <small class="text-muted" style="font-size: 12px;"
                              >{{ s.designation }}, {{ s.company }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="card mb-1 mt-1">
                      <div class="card-body p-1">
                        <div class="row">
                          <div class="col-4">
                            <div class="text-center">
                              <img
                                :src="event.host.photoURL"
                                alt=""
                                style="width: 100%; border-radius: 12px;"
                              />
                              <label
                                class="badge badge-danger"
                                style="position: absolute; left: 10px; bottom:0;"
                                >Host</label
                              >
                            </div>
                          </div>
                          <div class="col-8" style="text-align: left">
                            <div style="font-size: 16px;">
                              <b>{{ event.host.name }}</b>
                            </div>
                            <small class="text-muted" style="font-size: 12px;"
                              >{{ event.host.designation }},
                              {{ event.host.company }}</small
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="event.sponsors.length > 0"
                    style="position: absolute; bottom: 0px; width: 90%; background: #101010"
                  >
                    <h5
                      style="text-align: center; font-family: 'Vidaloka', serif;margin-top: 3%;"
                    >
                      Event Sponsors
                    </h5>
                    <carousel-3d
                      v-if="event.sponsors.length >= 3"
                      :autoplay="true"
                      :autoplay-timeout="5000"
                      :controls-visible="true"
                      :controls-prev-html="'&#10092;'"
                      :controls-next-html="'&#10093;'"
                      :clickable="true"
                      :display="3"
                      :width="200"
                      :height="80"
                    >
                      <slide
                        v-for="(slide, i) in event.sponsors"
                        :index="i"
                        :key="i"
                        class="text-center"
                      >
                        <template
                          slot-scope="{
                            index,
                            isCurrent,
                            leftIndex,
                            rightIndex,
                          }"
                        >
                          <figure
                            data-toggle="modal"
                            data-target="#sponsorModal"
                            @click="openSponsor(slide)"
                            style="cursor: pointer"
                          >
                            <img
                              style="width: 60px; height: 60px; text-align: center; border-radius: 50%;"
                              :data-index="index"
                              :class="{
                                current: isCurrent,
                                onLeft: leftIndex >= 0,
                                onRight: rightIndex >= 0,
                              }"
                              :src="slide.sponsor_img"
                            />
                            <figcaption>
                              <b>{{ slide.sponsor_name }}</b>
                            </figcaption>
                          </figure>
                        </template>
                      </slide>
                    </carousel-3d>
                    <div class="row" v-else-if="event.sponsors.length === 2">
                      <div
                        class="col-6 text-center"
                        v-for="(slide, i) in event.sponsors"
                        :key="i"
                      >
                        <figure
                          data-toggle="modal"
                          data-target="#sponsorModal"
                          @click="openSponsor(slide)"
                          style="cursor: pointer"
                        >
                          <img
                            style="width: 60px; height: 60px; text-align: center; border-radius: 50%;"
                            :src="slide.sponsor_img"
                          />
                          <figcaption>
                            <b>{{ slide.sponsor_name }}</b>
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                    <div class="row" v-else-if="event.sponsors.length === 1">
                      <div
                        class="col-12 text-center"
                        v-for="(slide, i) in event.sponsors"
                        :key="i"
                      >
                        <figure
                          data-toggle="modal"
                          data-target="#sponsorModal"
                          @click="openSponsor(slide)"
                          style="cursor: pointer"
                        >
                          <img
                            style="width: 60px; height: 60px; text-align: center; border-radius: 50%;"
                            :src="slide.sponsor_img"
                          />
                          <figcaption>
                            <b>{{ slide.sponsor_name }}</b>
                          </figcaption>
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card"
                style="background: #101010;"
                v-if="audience_bool"
              >
                <!-- <div class="card-header">
									<b>Audience</b>
								</div>-->
                <div class="card-body" style="height: 80vh; overflow-y: auto;">
                  <div
                    class="btn-group"
                    role="group"
                    aria-label="Basic example"
                    style="width: 70%; margin: 0px 50px;"
                  >
                    <button
                      @click="showGridView"
                      id="gridViewId"
                      type="button"
                      class="btn btn-outline-primary activeView btn-sm"
                      style="font-size: 12px;"
                    >
                      Grid
                    </button>
                    <button
                      @click="showListView"
                      id="listViewId"
                      type="button"
                      class="btn btn-outline-primary btn-sm"
                      style="font-size: 12px;"
                    >
                      List
                    </button>
                  </div>
                  <hr />
                  <div
                    class="audience"
                    v-if="audience.length > 0 && listview_bool"
                  >
                    <div
                      class="card card-white mb-2"
                      style="background: #1b1b1b; border: 0.1px solid #1b1b1b; border-radius: 8px"
                      v-for="(a, i) in audience"
                      :key="i"
                    >
                      <div class="card-body p-2">
                        <div style="display: flex">
                          <div style="width: 50px; margin: 2px;">
                            <img
                              class="img-responive"
                              :src="a.photoURL"
                              style="width: 100%; border: 1px solid #979797; border-radius: 12px"
                              :alt="a"
                            />
                          </div>
                          <div style="width: -moz-available;" class="m-1">
                            <b v-if="a.name !== ''">{{ a.name }}</b>
                            <b v-else>User Name</b>
                            <p class="mb-0">
                              <small class v-if="a.role === 'host'">Host</small>
                              <small class v-else-if="a.role === 'speaker'"
                                >Speaker</small
                              >
                              <small class v-else>Attendee</small>
                            </p>
                          </div>
                          <!--<button class="chatButton">Chat</button>-->
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="audience"
                    v-else-if="audience.length > 0 && gridview_bool"
                  >
                    <div
                      class="row"
                      style="background: #101010;border-radius: 8px"
                    >
                      <div
                        class="column"
                        v-for="(a, i) in audience"
                        :key="i"
                        style="background-color: #1b1b1b; padding: 2px; border-radius: 10px; margin: 1px;"
                      >
                        <img
                          alt="picture"
                          :src="a.photoURL"
                          class="img-fluid"
                          style="width: 50px;"
                        />
                        <div class="audienceTooltip">
                          <!-- <b v-if="a.name !== '' && a.name.length > 11">{{ a.name.slice(0, 10) }}...</b> -->
                          <b
                            v-if="a.name !== '' && a.name.length <= 15"
                            style="font-size: 12px;"
                            >{{ a.name }}</b
                          >
                          <b
                            v-else-if="a.name !== '' && a.name.length > 15"
                            style="font-size: 12px;"
                            >{{ a.name.slice(0, 15) }}..</b
                          >
                          <!-- <b v-if="a.name !== '' && a.name.length <= 10">{{ a.name}}</b> -->
                          <b v-else>User Name</b>
                          <p class="mb-0" style="font-size: 10px;">
                            <small class v-if="a.role === 'host'">Host</small>
                            <small class v-else-if="a.role === 'speaker'"
                              >Speaker</small
                            >
                            <small class v-else>Attendee</small>
                          </p>
                        </div>
                        <div class="triangle-up"></div>
                      </div>
                      <!-- <div style="width: 65px; margin: 2px;">
														<img
															class="col-md-4"
															:src="a.photoURL"
															style="width: 100%; height: 100%; border: 1px solid #979797; border-radius: 12px"
															:alt="a"
														/>
													</div> -->
                      <!-- <div style="width: -moz-available" class="ml-1">
														<b v-if="a.name !== ''">{{ a.name }}</b>
														<b v-else>User Name</b>
														<p class="mb-0">
															<small class v-if="a.role === 'host'">Host</small>
															<small class v-else-if="a.role === 'speaker'"
																>Speaker</small
															>
															<small class v-else>Attendee</small>
														</p>
													</div> -->
                      <!-- <button class="chatButton">Chat</button>-->
                    </div>
                  </div>
                  <div
                    class="audience text-center"
                    v-else
                    style="min-height: 350px;"
                  >
                    <div
                      style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%)"
                    >
                      <svg
                        width="60"
                        height="60"
                        style="margin-bottom: 5%;"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <image
                          href="../assets/audience.svg"
                          width="60"
                          height="60"
                        />
                      </svg>
                      <br />
                      <span>
                        <b>You are the first</b>
                      </span>
                      <p>No has joined till this time.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card"
                id="live"
                style="background: #101010; height: 80vh !important; display: none;overflow: auto"
              >
                <!-- <div class="card-header"><b>Chats</b></div> -->
                <div class="card-body p-2" v-if="uid !== undefined">
                  <div class="sendbox">
                    <div class="form-group pt-2" id="accordion">
                      <div v-if="!isStreamSetup">
                      <input
                        type="text"
                        class="form-control"
                        v-model="streamKey"
                        placeholder="Paste your facebook stream key here..."
                        aria-label="Facebook Stream key"
                      />
                      <input
                        type="text"
                        class="form-control mt-3 mb-3"
                        v-model="youtubeStreamKey"
                        placeholder="Paste your youtube stream key here..."
                        aria-label="Youtube Stream key"
                      />
                      <button
                        @click="setupStream"
                        class="btn btn-primary mt-2 btn-block"
                        type="button"
                        id="general-send-button"
                        style="margin-left: 2px;"
                        v-if="
                          (this.$store.state.youtubeStreamKey !== '' ||
                            this.$store.state.streamKey !== '')"
                      >
                        Setup Stream
                      </button>
                      <button
                        class="btn btn-primary mt-2 btn-block"
                        type="button"
                        id="general-send-button-disable"
                        style="margin-left: 2px;"
                        disabled
                        v-else
                      >
                        Setup Stream
                      </button>
                    </div>
                      <div v-else style="text-align: center">
                              <p>
                                <b>Stream has been setup</b>
                                <br />
                                <a
                                  v-on:click.prevent="updateLiveStatus"
                                  class="text-primary"
                                  style="cursor:pointer;"
                                  >Change your stream key</a
                                >
                              </p>
                            </div>
                      <div style="position: absolute;bottom: 0;width: 95%">
                        <!-- Facebook Card -->
                        <div class="card mt-2">
                          <div class="card-header">
                            <a
                              class="collapsed card-link"
                              data-toggle="collapse"
                              href="#facebook"
                              style="font-size: 14px"
                            >
                              How to setup Facebook live Stream ?
                            </a>
                          </div>
                          <div
                            id="facebook"
                            class="collapse"
                            data-parent="#accordion"
                          >
                            <div
                              class="card-body"
                            >
                              <div style="display: block">
                                <div>
                                  Follow the instructions to get your facebook
                                  stream key,
                                  <ol>
                                    <li>
                                      Go to
                                      <a
                                        href="https://www.facebook.com/live/producer/"
                                        target="_blank"
                                        >facebook live video</a
                                      >
                                      and click on live video
                                    </li>
                                    <li>
                                      In stream setup tab click on Use stream
                                      key
                                    </li>
                                    <li>
                                      Copy live stream key from live stream
                                      setup card.
                                    </li>
                                    <li>Paste above</li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Youtube card -->
                        <div class="card mt-2">
                          <div class="card-header">
                            <a
                              class="collapsed card-link"
                              data-toggle="collapse"
                              href="#youtube"
                              style="font-size: 14px"
                            >
                              How to setup Youtube Live Stream ?
                            </a>
                          </div>
                          <div
                            id="youtube"
                            class="collapse"
                            data-parent="#accordion"
                          >
                            <div
                              class="card-body"
                            >
                              <div style="display: block">
                                <div>
                                  Follow the instructions to get your youtube
                                  stream key,
                                  <ol>
                                    <li>
                                      Go to
                                      <a
                                        href="https://studio.youtube.com"
                                        target="_blank"
                                        >studio.youtube.com</a
                                      >
                                      and click on Create in top navigation bar
                                    </li>
                                    <li>Click Go Live</li>
                                    <li>
                                      Choose Stream option from left side
                                      navigational panel
                                    </li>
                                    <li>
                                      Then, fill out basic information like
                                      title, audience type & description etc.
                                      and Click Create Stream
                                    </li>
                                    <li>
                                      Copy the stream key from stream settings
                                      and paste above.
                                    </li>
                                  </ol>
                                </div>
                              </div>
                            </div>
                            
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="card"
                style="min-height: 350px; background: #101010; height: 80vh;"
                v-if="handraise_bool"
              >
                <!-- <div class="card-header"><b>Raise Hand Requests</b></div> -->
                <div
                  class="card-body"
                  style="height: 80vh; overflow-y: auto;"
                  v-if="handRequest.length > 0"
                >
                  <div
                    v-for="(item, index) in handRequest"
                    :key="index"
                    class="card card-white mb-2"
                    style="background: #000;"
                  >
                    <div class="card-body p-2">
                      <div
                        style="display: flex; justify-content: space-around;"
                      >
                        <div style="width: 65px; margin: 2px;">
                          <img
                            class="img-responsive"
                            :src="item.photoURL"
                            style="width: 100%; border: 1px solid #1b1b1b; border-radius: 12px"
                            :alt="item"
                          />
                        </div>
                        <div style="width: -moz-available" class="ml-1 mt-2">
                          <b>
                            {{
                              item.name.length >= 12
                                ? item.name.substr(0, 12) + ".."
                                : item.name
                            }}
                          </b>
                          <br />
                          <div class style="font-size: 10px">
                            {{ item.role.toUpperCase() }}
                          </div>
                        </div>
                        <div
                          v-if="item.isLeaveActive"
                          style="float: right; text-align: center"
                          class="mt-1"
                        >
                          <button
                            class="btn btn-outline-primary btn-sm"
                            @click="handleRequestApproval(true, item)"
                          >
                            Accept
                          </button>
                          <br />
                          <button
                            class="text-primary btn btn-sm"
                            @click="handleRequestApproval(false, item)"
                          >
                            Reject
                          </button>
                        </div>
                        <div v-else>
                          <button
                            class="btn btn-outline-danger btn-sm mt-2"
                            @click="handleRequestApproval('leave', item)"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="card-body"
                  style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%); text-align: center"
                >
                  <svg
                    width="60"
                    height="60"
                    style="margin-bottom: 5%;"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <image href="../assets/hand.svg" width="60" height="60" />
                  </svg>
                  <br />
                  <span>
                    <b>No request for raise hand</b>
                  </span>
                  <p>
                    If anyone wants to ask any questions then please click on
                    the hand raise button.
                  </p>
                </div>
              </div>
            </div>
            <div class="m-0" style="width: 60px;">
              <div
                class="card"
                style="height: 84vh; border-radius: 0px; border: 0px;"
              >
                <div
                  class="card-body text-center"
                  style="padding: 0px 0px 10px 0px; !important;"
                >
                  <div
                    :class="
                      [sessions_bool ? 'selected' : ''] + ' side-nav-item'
                    "
                    id="sessionBtn"
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center side-nav"
                      @click="showSessions()"
                    >
                      <span
                        :class="[
                          sessions_bool ? 'selectedIcon' : 'notSelected',
                        ]"
                      >
                        <i
                          class="fas fa-info-circle mb-0"
                          style="font-size: 20px;"
                        ></i>
                      </span>
                      <br />
                      <span
                        :class="[sessions_bool ? '' : 'notSelected']"
                        style="font-size: 12px;"
                        >Sessions</span
                      >
                    </a>
                  </div>
                  <div
                    :class="[chat_bool ? 'selected' : ''] + ' side-nav-item'"
                    id="chatBtn"
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center side-nav"
                      @click="showChats()"
                    >
                      <span
                        :class="[chat_bool ? 'selectedIcon' : 'notSelected']"
                      >
                        <i
                          class="far fa-comment-alt mb-0"
                          style="font-size: 20px;"
                        ></i>
                      </span>
                      <span
                        v-if="this.$store.state.newMessagesCount > 0"
                        class="badge badge-pill badge-primary"
                        style="position: absolute;right: 0;font-size: 10px;"
                        >{{ this.$store.state.newMessagesCount }}</span
                      >
                      <br />
                      <span
                        :class="[chat_bool ? '' : 'notSelected']"
                        style="font-size: 12px;"
                        >Chats</span
                      >
                    </a>
                  </div>
                  <div
                    :class="
                      [question_bool ? 'selected' : ''] + ' side-nav-item'
                    "
                    id="questionBtn"
                    @click="showQuestionsRequest()"
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center side-nav"
                      @click="showQuestionsRequest()"
                    >
                      <span :class="[question_bool ? '' : 'notSelected']">
                        <i class="fas fa-question" style="font-size: 20px;"></i>
                        <span
                          v-if="this.$store.state.newQnaCount > 0"
                          class="badge badge-pill badge-primary"
                          style="position: absolute;right: 0;font-size: 10px;"
                          >{{ this.$store.state.newQnaCount }}</span
                        >
                        <br />
                        <span style="font-size: 12px;">QnA</span>
                      </span>
                    </a>
                  </div>
                  <div
                    :class="
                      [audience_bool ? 'selected' : ''] + ' side-nav-item'
                    "
                    id="audienceBtn"
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center mt-3 side-nav"
                      @click="handleAudience"
                      style="position: relative; top: 3%; right: 2%"
                    >
                      <div>
                        <span
                          :class="[
                            audience_bool ? 'selectedIcon' : 'notSelected',
                          ]"
                        >
                          <i class="fa fa-users" style="font-size: 20px;"></i>
                        </span>
                      </div>
                      <span
                        style="font-size: 12px;"
                        :class="[audience_bool ? '' : 'notSelected']"
                        >Audience</span
                      >
                    </a>
                  </div>
                  <div
                    :class="[live_bool ? 'selected' : ''] + ' side-nav-item'"
                    id="liveBtn"
                    v-if="this.$store.state.role === 'host'"
                    v-show="
                      this.$store.state.isLive || this.$store.state.isStage
                    "
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center side-nav"
                      @click="showLive()"
                    >
                      <div
                        style="border-radius: 40px;background: #1B1B1B;font-size: 16px;width: 50px;margin-left: 10px;height: 25px"
                      >
                        <span
                          :class="[live_bool ? 'selectedIcon' : 'notSelected']"
                        >
                          <i
                            class="fab fa-facebook-square"
                            style="z-index: 3"
                          ></i>
                          <i
                            class="fab fa-youtube"
                            style="margin-left: 5px"
                          ></i>
                        </span>
                      </div>
                      <span
                        style="font-size: 12px;"
                        :class="[live_bool ? '' : 'notSelected']"
                        >Go Live</span
                      >
                    </a>
                  </div>
                  <div
                    :class="
                      [handraise_bool ? 'selected' : ''] + ' side-nav-item'
                    "
                    id="handRaiseBtn"
                    v-if="
                      this.$store.state.role === 'host' &&
                        this.$store.state.isLive
                    "
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center side-nav"
                      @click="showHandRaiseRequest()"
                    >
                      <div v-show="handRequest.length === 0">
                        <span
                          :class="[
                            handraise_bool ? 'selectedIcon' : 'notSelected',
                          ]"
                        >
                          <i
                            class="fas fa-hand-paper"
                            style="font-size: 20px;"
                          ></i
                          ><br />
                          <span style="font-size: 12px">
                            Request
                          </span>
                        </span>
                      </div>
                      <div
                        v-show="handRequest.length > 0"
                        style="font-size: 20px; font-weight: bold; margin-bottom: -5px;"
                        class="text-danger"
                      >
                        {{ handRequest.length }}
                      </div>
                      <div
                        v-show="handRequest.length > 0"
                        style="font-size: 12px;"
                      >
                        Requests
                      </div>
                    </a>
                  </div>
                  <!--									<div-->
                  <!--										class="side-nav-item"-->
                  <!--										v-if="this.$store.state.role === 'host'"-->
                  <!--									>-->
                  <!--										<a-->
                  <!--											href="javascript:void(0)"-->
                  <!--											class="text-center side-nav"-->
                  <!--											data-toggle="modal"-->
                  <!--											data-target="#addSpeaker"-->
                  <!--											@click="getSpeakerFunction()"-->
                  <!--										>-->
                  <!--                      <span style="color: #fff">-->
                  <!--                        <i class="fas fa-plus" style="font-size: 20px;"></i>-->
                  <!--                        <br />-->
                  <!--                        <span style="font-size: 12px;">Speakers</span>-->
                  <!--                      </span>-->
                  <!--										</a>-->
                  <!--									</div>-->
                  <div
                    :class="[setting_bool ? 'selected' : ''] + ' side-nav-item'"
                    id="settingsBtn"
                  >
                    <a
                      class="text-center side-nav"
                      id="settingButton"
                      href="#settingModal"
                      data-toggle="modal"
                      @click="showSetting"
                    >
                      <span :class="[setting_bool ? '' : 'notSelected']">
                        <i class="fas fa-cogs" style="font-size: 20px;"></i>
                        <br />
                        <span style="font-size: 12px;">Setting</span>
                      </span>
                    </a>
                  </div>
                  <div
                    :class="[hidden_bool ? 'selected' : ''] + 'side-nav-item'"
                    v-if="
                      this.$store.state.role === 'host' &&
                        this.$store.state.isStage
                    "
                    id="hiddenBtn"
                  >
                    <a
                      href="javascript:void(0)"
                      class="text-center mt-3 side-nav"
                      style="position: relative; top: 3%; right: 1%"
                      data-toggle="modal"
                      data-target="#hideHost"
                    >
                      <div v-show="!isHidden">
                        <span style="font-size: 12px;color: #fff">
                          <i
                            class="fas fa-eye-slash"
                            style="font-size: 20px;"
                          ></i> </span
                        ><br />
                        <span style="font-size: 12px;color: #fff">Hide</span>
                      </div>
                      <div v-show="isHidden">
                        <span style="font-size: 12px;color: #e8554d">
                          <i
                            class="fas fa-eye"
                            style="font-size: 20px;"
                          ></i> </span
                        ><br />
                        <span style="font-size: 12px;color: #e8554d"
                          >Unhide</span
                        >
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isMobile">
          <v-bottom-navigation
            v-show="isMobile"
            dark
            shift
            grow
            style="position:fixed;bottom: 0;z-index: 16"
          >
            <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileLive"
              v-show="this.$store.state.isLive && !this.$store.state.isStage"
            >
              <span>Live</span>
              <v-icon>fab fa-youtube</v-icon>
            </v-btn>

            <!-- <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileBackStage"
              v-show="this.$store.state.isStage && !this.$store.state.isLive"
            >
              <span>Backstage</span>
              <v-icon>fas fa-person-booth</v-icon>
            </v-btn>
-->
            <!-- <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileLounge"
              v-show="!this.$store.state.isLive && !this.$store.state.isStage"
            >
              <span>Lounge</span>
              <v-icon>fas fa-chalkboard-teacher</v-icon>
            </v-btn> -->

            <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileChats"
            >
              <span>Chats</span>
              <v-icon>fas fa-comment-alt</v-icon>
            </v-btn>

            <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileQnA"
            >
              <span>QnA</span>
              <v-icon>fas fa-question</v-icon>
            </v-btn>

            <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileAudience"
            >
              <span>Audience</span>
              <v-icon>fas fa-users</v-icon>
            </v-btn>

            <v-btn
              style="background-color: #ffb229;height: 60px;font-size: .6em;font-weight: 800"
              @click="showMobileSessions"
            >
              <span>Sessions</span>
              <v-icon>fas fa-info</v-icon>
            </v-btn>
          </v-bottom-navigation>
        </div>
        <div
          v-if="!this.$store.state.isChatConnect && uid !== undefined"
          class="chat-loading"
        >
          <h1>Connecting...</h1>
        </div>
      </div>
      <div v-else>
        <div class="card">
          <div
            class="card-body wrapper meeting p-0 text-center"
            style="height: 85vh; min-height: 400px; "
          >
            <div class="table-structure"></div>
            <div
              style="position: absolute; top: 50%; left: 50%; margin-right: -50%; transform: translate(-50%, -50%);"
            >
              <h3>
                Login to start the session
              </h3>
              <button
                id="vcPageLoginModal"
                data-toggle="modal"
                class="btn btn-primary"
                data-target="#loginModal"
              >
                Roger that.
              </button>
            </div>
          </div>
        </div>
      </div>
      <p
        @click="handleHorizontalScroll()"
        class="text-center d-block d-sm-none pt-1 text-primary horizontal-scroll"
      >
        Scroll to explore
        <i class="fas fa-arrow-right"></i>
      </p>
    </div>
    <div class="d-block d-sm-none text-center container" id="mobile-check">
      <div
        style="position: absolute;top: 50%;left: 50%;margin-right: -50%;transform: translate(-50%, -50%); text-align: center"
      >
        <h5>
          This is an interactive live session, which is best experienced on a
          laptop.
        </h5>
        <button class="btn btn-outline-primary disabled" @click="mobileCheck()">
          Continue
        </button>
      </div>
    </div>
    </div>
  <div v-else class="text-center">
    <i class="far fa-sad-tear" style="font-size: 88px"></i>
          <!--			    <h1 style="font-size: 50px; margin-bottom: 0px;"><b></b></h1>-->
          <h5 style="font-weight: lighter; font-size: 25px;">
            Apologies! we only support chrome browser,
            currently.
          </h5>
          <p class="text-muted">
            Due to limitations imposed by this browser, we are unable to
            get inside. Please use laptop or desktop with connect camera and
            microphones devices and use one of our supported browsers.
          </p>
          <hr />
          <p><b>We support following browsers on laptops.</b></p>
          <a
            href="https://www.google.com/chrome/"
            target="_blank"
            class="btn btn-outline-primary"
            style="border-radius: 5px;"
          >
            <img
              src="https://upload.wikimedia.org/wikipedia/commons/8/87/Google_Chrome_icon_%282011%29.png"
              style="width: 50px; height: 50px;"
              alt=""
              class="img-fluid"
            />
            <b>Chrome</b> by google
          </a>
  </div>
    <div
      class="modal"
      id="loginModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loginModal"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Login</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class id="close-login">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <br />
            <button
              @click="socialLogin('google')"
              class="btn btn-block btn-default btn-dark"
              style="display: flex; justify-content: center"
              id="google-signup"
            >
              <img
                alt="Google Logo"
                src="../assets/google-logo.png"
                class="mr-1"
                style="width: 40px;"
              />
              <span style="font-weight: bold; font-size: 18px; margin-top: 5px;"
                >Login with Google</span
              >
            </button>
            <br />
            <h6>
              <span>or</span>
            </h6>
            <router-link
              to="/signup"
              style="display: flex; justify-content: center"
              class="btn btn-block btn-default btn-dark"
              data-dismiss="modal"
              data-toggle="modal"
              aria-label="Close"
            >
              <span style="font-size: 25px; margin: 2px 10px;"
                ><b><i class="fas fa-envelope-open"></i></b
              ></span>
              <span style="font-weight: bold; font-size: 18px; margin-top: 7px;"
                >Login with Email</span
              >
            </router-link>
            <button
              @click="socialLogin('twitter')"
              class="btn btn-block btn-default d-none"
              style="background: #007bff;display: flex; justify-content: center"
              id="twitter-signup"
            >
              <img
                alt="Google Logo"
                src="../assets/twitter-logo.png"
                class="mr-1"
                style="width: 40px;"
              />
              <span
                style="font-weight: bold; font-size: 18px; margin-top: 5px; color: #fff;"
                >Login with Twitter</span
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="navigateModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="navigateModal"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body text-center">
            <span style="font-size: 80px;"
              ><i class="fas fa-question"></i
            ></span>
            <p>
              Do you really want to move
              <b>{{ navigateSession.session_name }}?</b>
            </p>
            <a
              class="btn btn-primary"
              @click="callExit"
              :href="
                '/event/' +
                  event.event_id +
                  '/agenda/' +
                  navigateSession.session_id
              "
              >Yes, Move in</a
            >
            <a
              class="btn btn-secondary ml-2"
              href="javascript:void(0)"
              data-dismiss="modal"
              aria-label="Close"
              >No</a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="settingModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="settingModal"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" style="background: rgba(0, 0, 0, 0.9)">
          <div class="modal-body">
            <Setting ref="setting" :permission="permission"></Setting>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="hideHost"
      tabindex="-1"
      role="dialog"
      aria-labelledby="hideHost"
      aria-hidden="true"
    >
      <div v-if="!isHidden" class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p style="font-weight: bold">
              Your video & audio will be hidden but still, you can control and
              manage the event.
            </p>
            <small
              >Note: It won't work if you are the only one in the studio.</small
            >
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="showHiddenIcon"
              id="hide-ok-button"
              class="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
            >
              Hide
            </button>
            <button
              type="button"
              id="hide-cancel-button"
              class="btn btn-secondary"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
      <div v-if="isHidden" class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p style="font-weight: bold">
              Your video & audio will be unhidden, you are going to live again..
            </p>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              @click="showHiddenIcon"
              id="unhide-okay-butto"
              class="btn btn-primary"
              data-dismiss="modal"
              aria-label="Close"
            >
              Unhide
            </button>
            <button
              type="button"
              id="unhide-cancel-button"
              class="btn btn-danger"
              data-dismiss="modal"
              aria-label="Close"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="addSpeaker"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addSpeaker"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Speaker's Email ID</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class id="speaker-close">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>Enter Gmail id of speakers:</p>
            <div class="form-group" v-for="(e, i) in speakers" :key="i">
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  v-model="e.email"
                  placeholder="Speaker's email"
                />
                <div class="input-group-append" v-if="speakers.length > 1">
                  <span
                    class="input-group-text btn btn-danger"
                    @click="removeSpeaker(i)"
                  >
                    <i class="fas fa-times"></i>
                  </span>
                </div>
              </div>
            </div>
            <button
              class="btn btn-sm btn-white"
              @click="addMoreSpeaker()"
              v-if="speakers.length >= 0 && speakers.length < 2"
            >
              <i class="fas fa-plus"></i> Add More
            </button>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              @click="inviteSpeakersFunction"
              id="submit-channel-name"
              class="btn btn-primary"
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal"
      id="invite"
      tabindex="-1"
      role="dialog"
      aria-labelledby="invite"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Invite Audience</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true" class id="invite-close">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <p>
              To invite audience copy below link
              <br />
            </p>
            <div class="form-group">
              <div class="input-group mb-3">
                <input
                  type="text"
                  class="form-control"
                  id="inviteLink"
                  placeholder="link"
                  :value="getInviteLink()"
                />
                <div class="input-group-append">
                  <span
                    class="input-group-text btn btn-primary"
                    id="copy-link"
                    @click="copyLink()"
                    >Copy</span
                  >
                </div>
              </div>
            </div>
            <label class="float-left"
              >For best experience request them to use their laptop.</label
            >
          </div>
          <div class="modal-footer">
            <button
              data-dismiss="modal"
              aria-label="Close"
              id="close-invite-name"
              class="btn btn-secondary"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <button
      style="display: none"
      data-toggle="modal"
      data-target="#feedbackModal"
      class="btn btn-primary"
      id="btn-feedback"
    >
      Feedback
    </button>
    <!-- Modal -->
    <div>
      <div
        class="modal fade"
        id="feedbackModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="feedbackModal"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content" style="background: rgba(0, 0, 0, 0.8)">
            <div class="modal-header">
              <h5>How was your experience?</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>How many stars will you give us?</label>
                <star-rating
                  :border-width="4"
                  :increment="0.5"
                  v-bind:star-size="30"
                  :rounded-corners="true"
                  :star-points="[
                    23,
                    2,
                    14,
                    17,
                    0,
                    19,
                    10,
                    34,
                    7,
                    50,
                    23,
                    43,
                    38,
                    50,
                    36,
                    34,
                    46,
                    19,
                    31,
                    17,
                  ]"
                  :show-rating="false"
                  @rating-selected="setRating"
                ></star-rating>
              </div>
              <div class="form-group">
                <label>Any feedback for us?</label>
                <textarea
                  class="form-control"
                  rows="6"
                  id="feedback_msg"
                  v-model="feedbackMsg"
                />
              </div>
              <div class="text-center">
                <button class="btn btn-primary" @click="sendFeedback">
                  Send feedback
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="sponsorModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="sponsorModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="sponsorTitle">
              Thank you to our sponsor.
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <figure>
              <img
                style="width: 100px; height: 100px; text-align: center; border-radius: 50%;"
                :src="sponsor.sponsor_img"
              />
              <figcaption>
                <h5>
                  <b>{{ sponsor.sponsor_name }}</b>
                </h5>
                <p class="text-muted">{{ sponsor.sponsor_message }}</p>
                <a
                  class="btn btn-primary"
                  target="_blank"
                  :href="sponsor.sponsor_website"
                  >Visit Link</a
                >
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import * as Cookies from "js-cookie";
import VideoCall from "@/components/events/VideoCallEvent";
import AgoraChatRoom from "@/components/events/Chat";
import AgoraQuestionChat from "@/components/events/QnA";
import Backstage from "@/components/events/Backstage1";
import social from "@/components/events/Social";
import Setting from "@/components/events/Setting";
import Swal from "sweetalert2";
import VideoPlayer from "@/components/VideoPlayer";
import EventSetting from "./EventSetting"
import firebase from "firebase";
import jquery from "jquery";
import { Carousel3d, Slide } from "vue-carousel-3d";
import "intro.js/minified/introjs.min.css";
var DetectRTC = require("detectrtc");
const introJS = require("intro.js");

// Cookies.remove("agora_user_id");
export default {
  components: {
    VideoCall,
    Backstage,
    AgoraChatRoom,
    AgoraQuestionChat,
    social,
    Setting,
    Carousel3d,
    Slide,
    VideoPlayer,
    EventSetting
  },
  data() {
    return {
      allowBrowser: false,
      liveStreamUrl: "",
      rating: 0,
      feedbackMsg: "",
      answers: [],
      user: {
        name: "",
      },
      videoProfile: "720p_1",
      channel: "",
      channel_name: "",
      transcode: "interop",
      attendeeMode: "video",
      baseMode: "avc",
      uid: undefined,
      appId: "",
      live_bool: false,
      chat_bool: false,
      sessions_bool: false,
      audience_bool: false,
      videocall_bool: true,
      handraise_bool: false,
      setting_bool: false,
      question_bool: false,
      isHidden: false,
      isSupportedBrowser: true,
      hidden_bool: false,
      listview_bool: false,
      gridview_bool: false,
      name: "",
      email: "",
      number: "",
      purpose: "",
      messsages: [],
      audience: [],
      memberList: this.$store.members,
      handRequest: [],
      channelAudienceCount: 0,
      isLeaveActive: true,
      speakers: [
        {
          email: "",
        },
      ],
      timerStartSession: 10,
      isStart: false,
      streams: 0,
      currentStream: {},
      permission: true,
      isFacebookLive: false,
      event: {},
      session: {},
      is_host: false,
      is_speaker: false,
      sponsor: {},
      eventLobby: false,
      readMoreActivated: false,
      navigateSession: "",
      isMobile: false,
      isSafari: false,
      mobileLive: true,
      mobileChats: false,
      mobileQnA: false,
      mobileAudience: false,
      mobileSessions: false,
      mobileLounge: false,
      defaultMobile: true,
      isStreamSetup: false
    };
  },
  computed: {
    streamKey: {
      get() {
        return this.$store.state.streamKey;
      },
      set(value) {
        this.$store.commit("updateStreamKey", value);
      },
    },
    youtubeStreamKey: {
      get() {
        return this.$store.state.youtubeStreamKey;
      },
      set(value) {
        this.$store.commit("updateYoutubeStreamKey", value);
      },
    },
    showPermission() {
      return this.$store.state.showPermission;
    }
  },
  watch: {
    showPermission(newValue, oldValue) {
      console.log(oldValue);
      const $ = this;
      setTimeout(() => {
      if (
        localStorage.getItem("user_info") !== null &&
        !this.$store.state.isLive && !newValue
      ) {
        if ($.attendeeMode !== "audience") {
          $.startIntro();
        } else {
          $.startAudienceIntro();
        }
      }
      // let elem = document.getElementsByClassName("introjs-tooltip");
      //   for(var i=0;i<elem.length;i++) {
      //     elem[i].style.color = "black";
      //   }
    }, 2000);
    }
  },
  mounted() {
    const $ = this;
    $.allowBrowser = DetectRTC.browser.name === 'Chrome' ? true : false;
    this.$store
      .dispatch("getEventStreamKey", { session_id: this.$route.params.session })
      .then((result) => {
        if (result.data.status === "success") {
          console.log('result: ', result);
          $.$store.state.streamKey = result.data.data.facebook_key;
          $.$store.state.youtubeStreamKey = result.data.data.youtube_key;
          if(result.data.data.facebook_key !== "" || result.data.data.youtube_key !== "" ){
            $.isStreamSetup = true
          }
        } else {
          console.log('not set result: ', result)
        }
      });
    DetectRTC.load(function() {
      if (DetectRTC.isMobileDevice) {
        $.isMobile = true;
      }
      if (DetectRTC.browser.isSafari) {
        $.isSafari = true;
      }
    });
    if ($.$route.params.session) {
      if (localStorage.getItem("user_info")) {
        $.checkUser();
        $.getAgoraTokenFunction();
        $.getEventDetailFunction();
        $.user = JSON.parse(localStorage.getItem("user_info"));
      } else {
        this.$router.push("/e/" + $.$route.params.id);
      }
    } else {
      $.$toast.open({
        message: "Sorry meeting id is required.",
        type: "error",
        position: "top",
        queue: true,
      });
    }
    $.user = JSON.parse(localStorage.getItem("user_info"));
    // console.log(
    //   "Get members data vs-- :",
    //   $.$store.state.members,
    //   " is attendee host: "
    // );
    $.$root.$on("newMessageNotifier", () => {
      if (!this.chat_bool) {
        this.$store.state.newMessagesCount += 1;
      }
    });
    $.$root.$on("takeFeedbackFromUser", () => {
      document.getElementById("btn-feedback").click();
    });
    $.$root.$on("updateVotes_1", (obj) => {
      $.clientPoll.answers.map((answer, index) => {
        answer.votes = obj.answers[index].votes;
      });
      $.polls.map((poll) => {
        if (poll.question === obj.question) {
          poll.answers = obj.answers;
        }
      });
    });
    $.$root.$on("newQnaNotifier", () => {
      if (!this.question_bool) {
        this.$store.state.newQnaCount += 1;
      }
    });
    $.$root.$on("clientSetSpeaker", () => {
      // console.log("clientSetSpeaker : API Call");
      $.getMeetingStatesFunction();
      $.getAgoraTokenFunction();
      $.$store.state.isSpeaker = true;
      this.$toast.open({
        message: "Host has assign you has a speaker.",
        type: "success",
        position: "top",
        queue: true,
      });
      window.location.reload();
    }),
      $.$root.$on("receiveChannelMemberCount", (data) => {
        $.channelAudienceCount = data;
      });
    $.$root.$on("submitSetting", () => {
      $.submitSetting();
    });
    $.$root.$on("pleaseHandleDeclineByHost", (uid) => {
      if ($.handRequest.length > 0) {
        $.handRequest.forEach((item, i) => {
          if (item.uid == uid) {
            $.handRequest.splice(i, 1);
          }
        });
      }
    });
    $.$root.$on("playUserStream", () => {
      $.isLeaveActive = false;
    });
    $.$root.$on("sendingBackIdForHandraise", (data, payload) => {
      for (var l = 0; l < $.handRequest.length; l++) {
        let item = $.handRequest[l];
        console.log(item.uid);
        if (item.uid == data) {
          $.$root.$emit("withdrawRequest", data);
        }
      }
      // data - hand raised user uid
      if ($.handRequest !== undefined && $.handRequest.length === 0) {
        $.$store.state.members.forEach((x) => {
          x.isLeaveActive = true;
          if (x.uid == data) {
            console.log(`${x.name} device info: ${JSON.stringify(payload)}`);
            $.handRequest.push(x);
            if ($.attendeeMode === "host") {
              this.$toast.open({
                message: "New raised hand Request",
                type: "success",
                position: "bottom",
                queue: true,
              });
            }
          }
        });
        // let da = {
        //   channel_id: this.$route.params.session,
        // };
        // $.$store.dispatch("getEventMembersData", da).then((resp) => {
        //   if (resp.data.status === "success") {
        //     $.memberList = resp.data.data;
        //     $.memberList.forEach((x) => {
        //       x.isLeaveActive = true;
        //       if (x.uid == data) {
        //         console.log(
        //           `${x.name} device info: ${JSON.stringify(payload)}`
        //         );
        //         $.handRequest.push(x);
        //         if ($.attendeeMode === "host") {
        //           this.$toast.open({
        //             message: "New raised hand Request",
        //             type: "success",
        //             position: "bottom",
        //           });
        //         }
        //       }
        //     });
        //     // console.log(
        //     //   "%c:$.memberList--",
        //     //   "background: #ff00dd; color: #00ff00",
        //     //   $.memberList
        //     // );
        //   }
        // });
      } else if ($.handRequest !== undefined && $.handRequest.length > 0) {
        let pushFlag = false;
        for (var i = 0; i < $.handRequest.length; i++) {
          let item = $.handRequest[i];
          console.log(item.uid);
          if (item.uid == data) {
            pushFlag = true;
          }
        }
        //   const pushFlag = $.handRequest.includes(data);
        if (!pushFlag) {
          // if (data.length > 0) {
          $.$store.state.members.forEach((x) => {
            // data = [data];
            // if (!data.includes(x.uid.toString())) {
            // 	x.isLeaveActive = true;
            //   $.handRequest.push(x);
            // }
            if (x.uid == data) {
              x.isLeaveActive = true;
              console.log(`${x.name} device info: ${JSON.stringify(payload)}`);
              $.handRequest.push(x);
              if ($.attendeeMode === "host") {
                this.$toast.open({
                  message: "New raised hand Request",
                  type: "success",
                  position: "bottom",
                  queue: true,
                });
              }
            }
          });
          // let da = {
          //   channel_id: this.$route.params.session,
          // };
          // $.$store.dispatch("getEventMembersData", da).then((resp) => {
          //   if (resp.data.status === "success") {
          //     $.memberList = resp.data.data;
          //     $.memberList.forEach((x) => {
          //       // data = [data];
          //       // if (!data.includes(x.uid.toString())) {
          //       // 	x.isLeaveActive = true;
          //       //   $.handRequest.push(x);
          //       // }
          //       if (x.uid == data) {
          //         x.isLeaveActive = true;
          //         console.log(
          //           `${x.name} device info: ${JSON.stringify(payload)}`
          //         );
          //
          //         $.handRequest.push(x);
          //         if ($.attendeeMode === "host") {
          //           this.$toast.open({
          //             message: "New raised hand Request",
          //             type: "success",
          //             position: "bottom",
          //           });
          //         }
          //       }
          //     });
          //   }
          // });
          // }
        }
      }
    });
    $.$root.$on("withdrawRequest", (data) => {
      if ($.handRequest.length > 0) {
        $.handRequest.forEach((item, i) => {
          if (item.uid == data) {
            $.handRequest.splice(i, 1);
          }
        });
      }
    });
    $.$root.$on("deletethisuserfromhandrequestarray", (uid) => {
      if ($.handRequest.length > 0) {
        $.handRequest.forEach((item, i) => {
          if (item.uid == uid) {
            $.handRequest.splice(i, 1);
          }
        });
      }
    });
    $.$root.$on("emptyHandRaise", () => {
      $.isHidden = false;
      if ($.handRequest.length > 0) {
        $.handRequest = [];
      }
    });
    /*$.$root.$on('handleHandRaise', () => {
							this.$toast.open({
								message: "Someone raised hand",
								type: "success",
								position: "top",
							});
						});*/
    $.$root.$on("receiveChannelMembers", (data) => {
      if (data.length > 0) {
        let da = {
          channel_id: this.$route.params.session,
        };
        this.$store.dispatch("getEventMembersData", da).then((resp) => {
          if (resp.data.status === "success") {
            $.$store.state.members = resp.data.data;
            // console.log(resp.data.data);
            $.audience = [];
            $.$store.state.channelMembers = data;
            $.$store.state.attendeeCount = data.length;
            $.$store.state.members.forEach((x) => {
              if (data.includes(x.uid.toString())) {
                $.audience.push(x);
              }
            });
            $.audience.sort(function(a, b) {
              var nameA = a.name.toLowerCase(),
                nameB = b.name.toLowerCase();
              if (nameA < nameB)
                //sort string ascending
                return -1;
              if (nameA > nameB) return 1;
              return 0; //default return value (no sorting)
            });
          }
        });
      }
    });
    
  },
  methods: {
    sendFeedback: function() {
      // console.log('feedback: ', feedbackMsg, this.rating)
      const data = {
        event_id: this.$route.params.id,
        session_id: this.$route.params.session,
        message: this.feedbackMsg,
        rating: this.rating,
      };
      this.$store.dispatch("submitFeedback", data).then((resp) => {
        if (resp.data.status == "success") {
          Swal.fire("Thanks for your feedback", "", "success").then(
            (result) => {
              if (result.value) {
                document.getElementById("btn-feedback").click();
              }
            }
          );
          this.feedbackMsg = "";
          this.rating = 0;
        }
      });
    },
    setRating: function(rating) {
      this.rating = rating;
    },
    showMobileLive() {
      this.mobileLive = true;
      this.mobileChats = false;
      this.mobileQnA = false;
      this.mobileAudience = false;
      this.mobileSessions = false;
      this.mobileLounge = false;
      this.defaultMobile = false;
    },
    showMobileChats() {
      this.mobileLive = false;
      this.mobileChats = true;
      this.mobileQnA = false;
      this.mobileAudience = false;
      this.mobileSessions = false;
      this.mobileLounge = false;
      this.defaultMobile = false;
    },
    showMobileQnA() {
      this.mobileLive = false;
      this.mobileChats = false;
      this.mobileQnA = true;
      this.mobileAudience = false;
      this.mobileSessions = false;
      this.mobileLounge = false;
      this.defaultMobile = false;
    },
    showMobileAudience() {
      this.mobileLive = false;
      this.mobileChats = false;
      this.mobileQnA = false;
      this.mobileAudience = true;
      this.mobileSessions = false;
      this.mobileLounge = false;
      this.defaultMobile = false;
    },
    showMobileLounge() {
      this.mobileLive = false;
      this.mobileChats = false;
      this.mobileQnA = false;
      this.mobileAudience = false;
      this.mobileSessions = false;
      this.mobileLounge = true;
      this.defaultMobile = false;
    },
    showMobileSessions() {
      this.mobileLive = false;
      this.mobileChats = false;
      this.mobileQnA = false;
      this.mobileAudience = false;
      this.mobileSessions = true;
      this.mobileLounge = false;
      this.defaultMobile = false;
      document.getElementsByClassName("carousel-3d-container")[0].style.height =
        "80px";
    },
    totalVotesForHost(answers) {
      // console.log("Totalvotesforhost");

      let totalVotes = 0;
      answers.filter((a) => {
        if (!isNaN(a.votes) && a.votes > 0) totalVotes += parseInt(a.votes);
      });
      return totalVotes;
    },
    calcAnswersForHost(answers) {
      // console.log("calcAnswersForHost");
      if (this.totalVotesForHost(answers) === 0)
        return answers.map((a) => {
          a.percent = "0%";
          return a;
        });
      //Calculate percent
      return answers.filter((a) => {
        if (!isNaN(a.votes) && a.votes > 0)
          a.percent =
            Math.round(
              (parseInt(a.votes) / this.totalVotesForHost(answers)) * 100
            ) + "%";
        else a.percent = "0%";

        return a;
      });
    },
    startAudienceIntro() {
      const $ = this;
      const length = this.$store.state.tables.length;
      introJS
        .introJs()
        .onbeforechange(function(targetElement) {
          if (targetElement.id === "chatBtn") {
            $.showChats();
          } else if (targetElement.id === "questionBtn") {
            $.showQuestionsRequest();
          } else if (targetElement.id === "audienceBtn") {
            $.showAudience();
          } else if (targetElement.id === "liveBtn") {
            $.showLive();
          } else if (targetElement.id === "handRaiseBtn") {
            $.showHandRaiseRequest();
          } else if (targetElement.id === "settingsBtn") {
            $.showSetting();
          } else {
            if (targetElement.id === null) {
              introJS.introJS().nextStep();
              introJS.introJS().nextStep();
            }
          }
        })
        .setOptions({
          steps: [
            {
              element: document.querySelector(`#t${length}`),
              intro:
                "Grab a seat on a table, to have a 1-4 people converation.",
              position: "left",
            },
            // {
            //   element: document.querySelector("#table-canvas"),
            //   intro: "All the video stream will be visible here.",
            //   position: "left",
            // },
            // {
            //   element: document.querySelector("#mediaControl"),
            //   intro: "Show/Hide - Video <br/>Mute/Unmute - Audio",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#screen-share"),
            //   intro: "You can share Entire Screen, Application Window or Chrome tab",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#leave-table"),
            //   intro: "Click here to leave the group meeting",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#chatBtn"),
            //   intro: "Communicate with the panel members and fellow audience",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#questionBtn"),
            //   intro: "If you have any doubt, do not hesitate to ask a question.",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#audienceBtn"),
            //   intro: "Shows list of current active members",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#liveBtn"),
            //   intro: "Special feature to go live on social media like facebook, youtube",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#handRaiseBtn"),
            //   intro: "Audience can join the video call, all you need to do is accept hand raise",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#settingsBtn"),
            //   intro: "Change Camera and Audio device from settings",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#start-session"),
            //   intro: "Click Start Session to start live streaming",
            //   position: "left",
            // }
          ],
        })
        .start();
    },
    startIntro() {
      const $ = this;
      const length = this.$store.state.tables.length;
      introJS
        .introJs()
        .onchange(function(targetElement) {
          if (targetElement.id === "chatBtn") {
            $.showChats();
          } else if (targetElement.id === "questionBtn") {
            $.showQuestionsRequest();
          } else if (targetElement.id === "audienceBtn") {
            $.showAudience();
          } else if (targetElement.id === "liveBtn") {
            $.showLive();
          } else if (targetElement.id === "handRaiseBtn") {
            $.showHandRaiseRequest();
          } else if (targetElement.id === "settingsBtn") {
            $.showSetting();
          } else {
            if (targetElement.id === null) {
              introJS.introJS().nextStep();
              introJS.introJS().nextStep();
            }
          }
        })
        .setOptions({
          steps: [
            {
              element: document.querySelector(`#t${length}`),
              intro:
                "Grab a seat on a table, to have a 1-4 people converation.",
              position: "left",
            },
            // {
            //   element: document.querySelector("#table-canvas"),
            //   intro: "All the video stream will be visible here.",
            //   position: "left",
            // },
            // {
            //   element: document.querySelector("#mediaControl"),
            //   intro: "Show/Hide - Video <br/>Mute/Unmute - Audio",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#screen-share"),
            //   intro: "You can share Entire Screen, Application Window or Chrome tab",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#leave-table"),
            //   intro: "Click here to leave the group meeting",
            //   position: "left"
            // },
            {
              element: document.querySelector("#nav-go-to-backstage"),
              intro:
                "Click here to go to studio, it's a place where host and speakers interact",
              position: "left",
            },
            // {
            //   element: document.querySelector("#chatBtn"),
            //   intro: "Communicate with the panel members and fellow audience",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#questionBtn"),
            //   intro: "If you have any doubt, do not hesitate to ask a question.",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#audienceBtn"),
            //   intro: "Shows list of current active members",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#liveBtn"),
            //   intro: "Special feature to go live on social media like facebook, youtube",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#handRaiseBtn"),
            //   intro: "Audience can join the video call, all you need to do is accept hand raise",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#collapsibleNavbar--w-0"),
            //   intro: "",
            //   position: "left"
            // },
            // {
            //   element: document.querySelector("#settingsBtn"),
            //   intro: "Change Camera and Audio device from settings",
            //   position: "left"
            // },
            {
              element: document.querySelector("#start-session"),
              intro: "Click Start Session to start live streaming",
              position: "left",
            },
          ],
        })
        .start();
    },
    openSponsor(sponsor) {
      this.sponsor = sponsor;
    },
    navigateAudi(s) {
      this.navigateSession = s;
    },
    updateLiveStatus() {
      this.isStreamSetup = false;
    },
    updateFacebookLiveStatus() {
      this.$store.state.isFacebookLive = !this.$store.state.isFacebookLive;
    },
    updateYoutubeLiveStatus() {
      this.$store.state.isYoutubeLive = !this.$store.state.isYoutubeLive;
    },
    mobileCheck() {
      jquery(`#wrapper`).removeClass("d-none");
      jquery(`#wrapper`).addClass("d-block");
      jquery(`#mobile-check`).removeClass("d-block");
      jquery(`#mobile-check`).addClass("d-none");
    },
    handleHorizontalScroll() {
      jquery(".horizontal-scroll").click(function() {
        var $scroll = jquery(".meeting");
        $scroll.scrollLeft($scroll.width() + 40);
      });
    },

    goLive() {
      this.$root.$emit("goFacebookLive");
    },
    goYoutubeLive() {
      this.$root.$emit("goYoutubeLive");
    },
    setupStream() {
      let data = {
        "session_id": this.$route.params.session,
        "facebook_key": this.$store.state.streamKey,
        "youtube_key": this.$store.state.youtubeStreamKey
      }
      this.$store.dispatch("storeEventStreamKey", data).then((resp) => {
        console.log(resp);
        if (resp.status === "success") {
          console.log("Stream keys stored");
          this.isStreamSetup = true;
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
      if(this.$store.state.isLive){
        this.$root.$on("startChannelLiveStream");
      }
    },
    showListView() {
      this.listview_bool = true;
      this.gridview_bool = false;
      // console.log("listview: " + this.listview_bool);
      // console.log("Audience: " + this.audience.length);
      document.getElementById("listViewId").classList.add("activeView");
      document.getElementById("gridViewId").classList.remove("activeView");
    },
    showGridView() {
      this.listview_bool = false;
      this.gridview_bool = true;
      // console.log("Gridview: " + this.gridview_bool);
      document.getElementById("listViewId").classList.remove("activeView");
      document.getElementById("gridViewId").classList.add("activeView");
    },
    showQuestionsView() {
      this.listview_bool = false;
      this.gridview_bool = true;
      // console.log("Gridview: " + this.gridview_bool);
      document.getElementById("pollsBtn").classList.remove("activeView");
      document.getElementById("questionsBtn").classList.add("activeView");
    },
    showPollsView() {
      this.listview_bool = false;
      this.gridview_bool = true;
      // console.log("Gridview: " + this.gridview_bool);
      document.getElementById("questionsBtn").classList.remove("activeView");
      document.getElementById("pollsBtn").classList.add("activeView");
    },
    copyLink() {
      /* Get the text field */
      var copyText = document.getElementById("inviteLink");
      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /*For mobile devices*/
      /* Copy the text inside the text field */
      document.execCommand("copy");
      /* Alert the copied text */
      this.$toast.open({
        message: "Link Copied",
        type: "success",
        position: "top",
        queue: true,
      });
    },
    getInviteLink() {
      return window.location;
    },
    startSession() {
      const $ = this;
      $.$store.state.isSessionTimerDisabled = true;
      $.$root.$emit("clientStartTheSession");
      this.clr = setInterval(function() {
        if ($.timerStartSession === 0) {
          $.timerStartSession = 10;
          clearInterval($.clr);
          $.$store.state.isLive = true;
          $.$store.state.isNetworking = false;
          $.$store.state.isBreak = false;
          $.$store.state.isEnd = false;
          $.postMeetingStatus();
        } else {
          $.timerStartSession = $.timerStartSession - 1;
        }
        // console.log($.timerStartSession);
      }, 1000);
    },
    postMeetingStatus() {
      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("storeEventMeetingStates", data).then((resp) => {
        if (resp.data.status === "success") {
          console.log("Wonderful states stored");
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    getAgoraTokenFunction: function() {
      const $ = this;
      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventAgoraToken", data).then((resp) => {
        if (resp.data.status === "success") {
          $.token = resp.data.data.rtc_token;
          $.channel = resp.data.data.unique_id;
          $.channel_name = resp.data.data.event_name;
          $.attendeeMode = resp.data.data.role;
          $.uid = resp.data.data.uid;
          $.$store.state.role = resp.data.data.role;
        } else {
          if (
            resp.data.data ===
            "Sorry, you are not registered, for this event. Please register."
          ) {
            $.$router.push("/e/" + $.$route.params.id);
          }
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    getEventDetailFunction: function() {
      let data = {
        event_id: this.$route.params.id,
      };
      this.$store.dispatch("getEventDetail", data).then((resp) => {
        if (resp.data.status === "success") {
          this.event = resp.data.data;
          this.event.sessions.forEach((x) => {
            x.readMoreActivated = false;
            if (x.session_id === this.$route.params.session) {
              console.log(x);
              this.session = x;
            }
          });
          if (localStorage.getItem("user_info")) {
            if (this.event.host.id === this.user.id) {
              this.is_host = true;
            }
            this.event.speakers.forEach((x) => {
              if (x.id === this.user.id) {
                this.is_speaker === true;
              }
            });
          }
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    // getEventSessionDetailFunction: function () {
    //   let data = {
    //     "event_id": this.$route.params.id,
    //     "session_id": this.$route.params.session
    //   }
    //   this.$store.dispatch('getEventSessionDetail', data).then(resp => {
    //     if (resp.data.status === "success") {
    //       this.event = resp.data.data
    //    } else {
    //       this.$toast.open({
    //         message: resp.data.data,
    //         type: 'error',
    //         position: 'top'
    //       });
    //     }
    //   })
    // },
    stopSessionTimer() {
      const $ = this;
      $.$store.state.isSessionTimerDisabled = false;
      this.timerStartSession = 10;
      clearInterval(this.clr);
      $.$root.$emit("clientHostHasStoppedTimer");
    },
    onStageFunction: function(bool) {
      // console.log(bool);
      this.$store.state.isStage = bool;
    },
    handleRequestApproval: function(bool, userData) {
      const $ = this;
      if (bool === "leave") {
        // this.isLeaveActive = true
        // console.log("Streams: ", $.$store.state.streamCount);
        // $.streams -= 1;
        if ($.$store.state.streamCount === 1) {
          this.$toast.open({
            message: "Can't remove a single stream",
            type: "error",
            position: "top",
            queue: true,
          });
          $.streams++;
        } else {
          $.handRequest.forEach((item, i) => {
            if (item.uid == userData.uid) {
              $.handRequest.splice(i, 1);
            }
          });
          $.$root.$emit("handleLeaveListener", userData.uid);
          $.$root.$emit("removeVideoLayoutChange", userData.uid);
          // this.$root.$emit("sendingHostResponse", false, userData);
        }
      } else {
        if (bool === true) {
          if ($.handRequest.length > 0) {
            $.handRequest.forEach((item) => {
              if (item.uid == userData.uid) {
                //bug here $.handRequest is not behaving reactive in nature
                // fixed :)
                $.$set(item, item.isLeaveActive, false);
                item.isLeaveActive = false;
              }
            });
          }
        }
        $.$root.$emit("sendingHostResponse", bool, userData);
      }
    },
    inviteSpeakersFunction: function() {
      let check = 0;
      this.speakers.forEach((e) => {
        if (e.email === "") {
          check = 1;
        }
        if (e.email === this.user.email) {
          check = 2;
        }
      });
      if (check === 0) {
        // let $ =this;
        let data = {
          channel_id: this.$route.params.session,
          emails: this.speakers,
        };
        this.$store.dispatch("inviteEventSpeakers", data).then((resp) => {
          if (resp.data.status === "success") {
            this.$toast.open({
              message: resp.data.data,
              type: "success",
              position: "top",
              queue: true,
            });
            // this.$store.isSpeaker = true
            this.$root.$emit("setSpeaker", this.speakers);
            document.getElementById("speaker-close").click();
            this.speakers = {
              email: "",
            };
          } else {
            this.$toast.open({
              message: resp.data.data,
              type: "error",
              position: "top",
              queue: true,
            });
          }
        });
      } else {
        if (check === 2) {
          this.$toast.open({
            message: "You are already a host.",
            type: "error",
            position: "top",
            queue: true,
          });
        } else {
          this.$toast.open({
            message: "E-mail can't be empty",
            type: "error",
            position: "top",
            queue: true,
          });
        }
      }
    },
    removeSpeaker: function(i) {
      this.speakers.splice(i, 1);
    },
    addMoreSpeaker: function() {
      this.speakers.push({
        email: "",
      });
    },
    handleAudience() {
      // this.$root.$emit("updateTable");
      this.gridview_bool = true;
      this.showAudience();
      // this.getAudience();
    },
    // getAudience() {
    //   const $ = this;
    //   $.$root.$emit("getAudience");
    // },
    callExit: function() {
      // let cnfrm = window.confirm("Do you really want to leave the page ?");
      // if (cnfrm) {
      //
      // }
      this.$root.$emit("exit");
      window.location.href = "/e/" + this.$route.params.id;
    },
    initUid: function(uid) {
      this.uid = uid;
    },
    showSetting() {
      this.$refs.setting.showSetting();
    },
    showHiddenIcon: function() {
      let $ = this;
      let data = {
        id: this.uid,
        isHidden: this.isHidden,
      };
      if (
        this.$store.state.streamCount === 1 &&
        this.$store.state.role === "host" &&
        !$.isHidden
      ) {
        // console.log("Role: ", this.$store.state.role);
        $.$toast.open({
          message:
            "Only host can't be hide himself. Please add few more participants.",
          type: "error",
          position: "top",
        });
      } else if (this.$store.state.isScreenShare) {
        $.$toast.open({
          message: "Can't hide on screen share, please stop and then hide.",
          type: "error",
          position: "top",
        });
      } else {
        if (
          $.$store.state.streamKey === "" &&
          $.$store.state.youtubeStreamKey === ""
        ) {
          $.streams = this.$store.state.streamCount;
          this.isHidden = !this.isHidden;
          this.$root.$emit("hideHost_1", data);
        } else {
          this.$toast.open({
            message: "You cannot hide while you are live on facebook or youtube",
            type: "error",
            position: "top",
          });
        }
      }
    },
    showSessions: function() {
      this.chat_bool = false;
      this.sessions_bool = true;
      this.audience_bool = false;
      this.setting_bool = false;
      this.handraise_bool = false;
      this.question_bool = false;
      this.live_bool = false;
      document.getElementById("chat").style.display = "none";
      document.getElementById("question_chat").style.display = "none";
      document.getElementById("live").style.display = "none";
    },
    showAudience: function() {
      this.chat_bool = false;
      this.sessions_bool = false;
      this.audience_bool = true;
      this.setting_bool = false;
      this.handraise_bool = false;
      this.question_bool = false;
      this.live_bool = false;
      document.getElementById("chat").style.display = "none";
      document.getElementById("question_chat").style.display = "none";
      document.getElementById("live").style.display = "none";
    },
    showChats: function() {
      const $ = this;
      this.chat_bool = true;
      this.sessions_bool = false;
      this.audience_bool = false;
      this.setting_bool = false;
      this.handraise_bool = false;
      this.question_bool = false;
      this.live_bool = false;
      this.$store.state.newMessagesCount = 0;
      document.getElementById("chat").style.display = "block";
      document.getElementById("live").style.display = "none";
      document.getElementById("question_chat").style.display = "none";
      setTimeout(function() {
        $.$root.$emit("scrollDown");
      }, 500);
    },
    showLive: function() {
      this.chat_bool = false;
      this.sessions_bool = false;
      this.audience_bool = false;
      this.setting_bool = false;
      this.handraise_bool = false;
      this.question_bool = false;
      this.live_bool = true;
      document.getElementById("chat").style.display = "none";
      document.getElementById("question_chat").style.display = "none";
      document.getElementById("live").style.display = "block";
    },
    showHandRaiseRequest: function() {
      this.chat_bool = false;
      this.sessions_bool = false;
      this.audience_bool = false;
      this.setting_bool = false;
      this.handraise_bool = true;
      this.question_bool = false;
      this.live_bool = false;
      document.getElementById("chat").style.display = "none";
      document.getElementById("question_chat").style.display = "none";
      document.getElementById("live").style.display = "none";
    },
    showQuestionsRequest: function() {
      const $ = this;
      this.chat_bool = false;
      this.sessions_bool = false;
      this.audience_bool = false;
      this.setting_bool = false;
      this.handraise_bool = false;
      this.question_bool = true;
      this.live_bool = false;
      this.$store.state.newQnaCount = 0;
      document.getElementById("chat").style.display = "none";
      document.getElementById("live").style.display = "none";
      document.getElementById("question_chat").style.display = "block";
      setTimeout(function() {
        $.$root.$emit("scrollDown");
      }, 500);
    },
    hideMyVideo: function() {
      // this.videocall_bool = true
    },
    startVideoCall: function() {
      this.videocall_bool = false;
    },
    submitGetStarted: function() {
      if (this.name === "") {
        this.$toast.open({
          message: "Please enter name",
          type: "error",
          position: "top",
          queue: true,
        });
      } else if (this.email === "") {
        this.$toast.open({
          message: "Please enter email",
          type: "error",
          position: "top",
          queue: true,
        });
      } else if (this.purpose === "") {
        this.$toast.open({
          message: "Please enter purpose",
          type: "error",
          position: "top",
          queue: true,
        });
      } else if (this.number === "") {
        this.$toast.open({
          message: "Please enter phone number",
          type: "error",
          position: "top",
          queue: true,
        });
      } else {
        let data = {
          name: this.name,
          email: this.email,
          number: this.number,
          purpose: this.purpose,
        };
        this.$store.dispatch("getEventStarted", data).then((resp) => {
          if (resp.data.status === "success") {
            this.name = "";
            this.email = "";
            this.number = "";
            this.purpose = "";
            document.getElementById("close-get-started").click();
            this.$toast.open({
              message: "Thanks for reaching out, we will get back to you.",
              type: "success",
              position: "top",
              queue: true,
            });
          }
        });
      }
    },
    socialLogin(provider) {
      let providerAuth = "";
      if (provider === "google") {
        providerAuth = new firebase.auth.GoogleAuthProvider();
      } else if (provider === "twitter") {
        providerAuth = new firebase.auth.TwitterAuthProvider();
      }
      firebase
        .auth()
        .signInWithPopup(providerAuth)
        .then((result) => {
          // call an api here to store information in Mongodb Se
          this.userData = {
            name: result.user.displayName,
            email: result.user.email,
            photoURL: result.user.photoURL,
            phoneNumber: result.user.phoneNumber,
            user_type: "audience",
            company: "NA",
            designation: "NA",
            is_admin: false,
            location: "",
            credential: result.credential,
            token: "",
          };
          this.submitUserInfo();
        })
        .catch((err) => {
          alert("Oops. " + err.message);
        });
    },
    submitUserInfo: function() {
      this.$store.dispatch("insertEventUser", this.userData).then((resp) => {
        if (resp.data.status === "success") {
          this.login = true;
          this.videocall_bool = true;
          document.getElementById("close-login").click();
          localStorage.setItem("user_info", JSON.stringify(resp.data.data));
          this.getMeetingStatesFunction();
          this.getAgoraTokenFunction();
          // this.getScreenShareTokenFunction();
          this.user = resp.data.data;
          this.$toast.open({
            message: "Login successful, enjoy networking",
            type: "success",
            position: "top",
            queue: true,
          });
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
        }
      });
    },
    checkUser: function() {
      const $ = this;
      if (localStorage.getItem("user_info")) {
        this.login = true;
        this.userData = JSON.parse(localStorage.getItem("user_info"));
        let data = {
          email: this.userData.email,
          uid: this.userData.uid,
        };
        this.$store.dispatch("getUserInfo", data).then((resp) => {
          if (resp.data.status === "success") {
            $.user = JSON.parse(localStorage.getItem("user_info"));
            $.getMeetingStatesFunction();
            $.getSpeakerFunction();
          }
        });
      } else {
        this.login = false;
      }
    },
    getMeetingStatesFunction() {
      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventMeetingStates", data).then((resp) => {
        if (resp.data.status === "success") {
          console.log("Wonderful get states");
          this.sessions_bool = true;
          this.chat_bool = false;
          this.question_bool = false;
          this.$store.state.sid = resp.data.data.recording_id;
          console.log("meeting state: ", resp.data);
            let dirName = this.channel.replace(/[^A-Z0-9]/gi, "");
            // https://meetbeans-data.s3.ap-south-1.amazonaws.com/Hackathon14Augustpegeqcln/4d498e196c4233f073f3e48f3a3ee91e_Hackathon+14+August-pegeqcln.m3u8
            console.log(this.$store.state.sid);
            console.log(
              "live stream url: ",
              `https://meetbeans-data.s3.ap-south-1.amazonaws.com/${dirName}/${this.$store.state.sid}_${this.channel}.m3u8`
            );
            // https://meetbeans-data.s3.ap-south-1.amazonaws.com/sessionyatllxtv/03fec67bcd4bfab4a75ac4b949f9bdfc_session-yatllxtv.m3u8
            // https://meetbeans-data.s3.ap-south-1.amazonaws.com/${dirName}/${resp.data.data.recording_id}_${this.channel}.m3u8
            this.liveStreamUrl = `https://meetbeans-data.s3.ap-south-1.amazonaws.com/${dirName}/${this.$store.state.sid}_${this.channel}.m3u8`;
          
          
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
          // console.log("ERROR IS ON GETMeetingstates");
          this.$router.push("/e/" + this.$route.params.id);
        }
      });
    },
    getSpeakerFunction() {
      let data = {
        channel_id: this.$route.params.session,
      };
      this.$store.dispatch("getEventSpeakers", data).then((resp) => {
        if (resp.data.status === "success") {
          this.speakers = resp.data.data;
        } else {
          this.$toast.open({
            message: resp.data.data,
            type: "error",
            position: "top",
            queue: true,
          });
          // console.log("ERROR IS ON GetSpeakerFunction");
          this.$route.push("/");
        }
      });
    },
  },
  created() {
    // window.addEventListener("beforeunload", this.$root.$emit("updateTable"));
    // window.addEventListener("beforeunload", this.callExit);
  },
  beforeDestroy() {
    this.handRequest = [];
  },
};
</script>

<style scoped lang="scss">
@media screen and(max-width: 765) {
  .carousel-3d-container > * {
    height: 80px !important;
  }
}
#questionsBtn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding: 7px 16px;
  font-size: 12px;
}
#pollsBtn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  padding: 7px 16px;
  font-size: 12px;
}
.meeting .ag-header {
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.ag-header-lead {
  font-size: 16px;
  line-height: 35px;
}

.meeting .ag-footer {
  padding: 0 30px;
  display: flex;
  align-items: center;
}

.meeting .ag-main {
  position: relative;
}

.meeting .ag-footer :first-child {
  margin-right: 80px;
}

.header-logo {
  width: 60px;
  height: 35px;
  margin-right: 12px;
}

.ag-container {
  height: 85vh;
  width: 100%;
  margin: 0 auto;
  background: #1b1b1b;
  border-radius: 12px;
}

.round-table {
  width: 80.9px;
  height: 67.6px;
  background-color: rgb(86, 86, 86);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  border-radius: 14px;
}

.table-item {
  width: 230px;
  height: 250px;
  background-color: rgba(51, 51, 51, 0.8);
  display: inline-block;
  position: relative;
  border-radius: 16px;
  margin: 5px;
}

.chair {
  width: 38.6px;
  height: 38.9px;
  background-color: rgb(173, 172, 172);
  z-index: 2;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.chair-up {
  top: calc(50% - 45px);
}

.chair-down {
  top: calc(50% + 40px);
}

.chair-right {
  left: calc(50% + 40px);
}

.chair-left {
  left: calc(50% - 40px);
}

.chair.chair-up::after {
  top: -4px;
}

.chair.chair-left::after {
  left: -4px;
  height: 38.89px;
  width: 7.9px;
}

.chair.chair-right::after {
  right: -4px;
  height: 38.89px;
  width: 7.9px;
}

.chair.chair-down::after {
  bottom: -4px;
}

.chair::after {
  display: block;
  content: "";
  width: 38.89px;
  height: 7.9px;
  background-color: rgb(140, 140, 140);
  position: absolute;
}

.meeting-stage {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-right: -50%;
  transform: translate(-50%, -50%);
}

.flex-width {
  min-width: 500px;
  width: -moz-available;
  width: -webkit-fill-available;
  width: stretch;
}

.table-structure {
  background: url("../assets/full-table-stucture.png");
  background-size: cover;
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  filter: blur(6px);
  -webkit-filter: blur(6px);
}

.chat-loading {
  position: absolute;
  top: 50%;
  left: -135%;
  z-index: 100;
  transform: translate(-50%, -50%);
  text-align: center;
}

.selected-chat {
}

.selected {
  position: relative;
  right: 2%;
  background-color: #101010;
  border-radius: 0px 10px 10px 0px;
  // margin-right: 10%;
}

.notSelected {
  color: #fff;
}

.selectedIcon {
  color: #ffc107;
}

.border {
  border: 1px solid #101010;
  border-radius: 10px;
}

.chatButton {
  margin-left: 19px;
  margin-top: 1rem;
  width: 63px;
  height: 28px;
  border-radius: 4px;
  border: solid 1px #ffb229;
  background-color: #1b1b1b;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.71;
  letter-spacing: normal;
  color: #ffb229;
}

#submit-setting {
}

.row {
  display: flex;
  flex-wrap: wrap;
  padding: 0 4px;
  text-align: center;
}

/* Create four equal columns that sits next to each other */
.column {
  position: relative;
  flex: 25%;
  max-width: 21%;
  cursor: pointer;
  margin: 2% 2%;
}

.column img {
  vertical-align: middle;
  width: 100%;
  border-radius: 10px;
}

.column .audienceTooltip {
  visibility: hidden;
  width: 110px;
  background-color: #fff;
  color: #000;
  text-align: center;
  padding: 5px 0px;
  border-radius: 6px;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: 110%;
  left: -30%;
  z-index: 1;
}

.column .triangle-up {
  visibility: hidden;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid #fff;
  /* Position the tooltip text - see examples below! */
  position: absolute;
  top: 99%;
  left: 45%;
  z-index: 1;
}

.column:hover .audienceTooltip {
  visibility: visible;
}

.column:hover .triangle-up {
  visibility: visible;
}

/* Responsive layout - makes a two column-layout instead of four columns */
@media screen and (max-width: 800px) {
  .column {
    flex: 50%;
    max-width: 50%;
    margin: 10px 0;
  }
}

/* Responsive layout - makes the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 600px) {
  .row {
    width: 100%;
    margin: auto;
  }
  .column {
    flex: 100%;
    max-width: 50%;
    margin: 10px 10px;
  }
}

@media only screen and (max-width: 1000px) {
  .chat-loading {
    left: -75%;
  }
}

@media only screen and (min-width: 1000px) and (max-width: 1500px) {
  .chat-loading {
    left: -105%;
  }
}

@media only screen and (max-width: 575px) {
  .flex-width {
    min-width: 100vw;
  }
}

#go-to-lounge {
}

.side-nav-item {
  padding-top: 10px;
  margin-bottom: 10px;
  width: 70px;
  height: 60px;
  z-index: 3;
}

h6 {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid rgb(87, 81, 81);
  line-height: 0.1em;
  margin: 10px 0 20px;
}

h6 span {
  background: #1b1b1b;
  padding: 0 10px;
}
.carousel-3d-slide {
  background-color: transparent !important;
  border-color: transparent !important;
  border-style: none !important;
}
</style>
